import React, {
  useContext,
  useEffect,
  useState,
} from "react";
//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/Fields/inputFields";
import CustomStepper from "../../components/Stepper/customStepper";
import VerticalStepper from "../../components/Stepper/verticalStepper";
import { useDispatch, useSelector } from "react-redux";
import { registerPropertyApi } from "../../../service/property/addNewProperty";
import { updatePropertyApi } from "../../../service/property/updateProperty";
import AssignUsers from "../users/AssignUsers";
import { getPropertyById } from "../../../service/property/getPropertyById";
import { getGstinDetailsApi } from "../../../service/vendor/getGstinDetailsApi";
import ResponceForAPI from "../../components/backdrop/backdropLoader";
import { setPropertyRegData } from "../../../feature/propertyRegistrationSlice";
import { toast,ToastContainer } from "react-toastify";
import { setLoading } from "../../../feature/authSlice";
import ViewVendorsAddProperty from "../vendors/assignedVendors/assignedVendorsAddProperty";
const RegisterProperty = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { changeBackground } = useContext(ThemeContext);
  const [activeStep, setActiveStep] = useState(1);
  const [propertyDetailsStep, setPropertyDetailsStep] = useState(1);
  const [serviceDetailsStep, setServiceDetailsStep] = useState(1)
  const [serviceProviderStep, setServiceProviderStep] = useState(1)
  const [apiLoading, setApiLoading] = useState(false)
  const propertyRegData = useSelector(state => state.propertyRegData.propertyRegData);
  const [isPropertyNameError, setIsPropertyNameError] = useState(false)
  const [isLocationCodeError, setIsLocationCodeError] = useState(false)
  const [isAddressLineOne, setIsAddressLineOne] = useState(false)
  const [isCityNameError, setIsCityNameError] = useState(false)
  const [isStateNameError, setIsStateNameError] = useState(false)
  const [isPincodeError,setIsPincodeError] = useState(false)
  const [isSuperAreaError,setIsSuperAreaError] = useState(false)
  const [isCarpetAreaError,setIsCarpetAreaError] = useState(false)
const [isStartDateError,setIsStartDateError] = useState(false)
const [isEndDateError,setIsEndDateError] = useState(false)
const [isDurationOfLeaseError,setIsDurationOfLeaseError] = useState(false)
const [isGstinError ,setIsGstinError] = useState(false)
const [newPropertyId,setNewPropertyId] = useState("")
const [loader,setLoader]=useState(false)
const [gstinFromApi,setGstinFromApi]=useState('')
// const [formData, setFormData] = useState({
//   locationName:  '',
//   locationCode: '',
//   gstin:  '',
// addressL1:'',
// addressL2:'',
// addressL3:'',
// city:'',
// state:'',
// pinCode:'',
// superArea:'',
// carpetArea:'',
// durationOfLease:"",
// startDate:"",
// endDate:"", // Format date if needed
//   // Add other fields as needed
// });
const [formData, setFormData] = useState()

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

  const steps = [
    { h: "Property", icons: "home_work" },
    { h: "Service/Vendors", icons: "online_prediction" },
    { h: "Users ", icons: "person" },
  ];

  const propertyFormSteps = [
    { h: "Property Details" },
    { h: "Address" },
    { h: "Built Up" },
    { h: "Validity" },
  ];
  const ServiceFormSteps = [
    { h: "Basic Details" },
    // { h: "Service Details" },
    // { h: "Address" },

  ];

  const serviceProviderFormSteps = [
    { h: "Number of Services Providers" },
    // { h: "Service Provider Details" },
    // { h: "Bank Details" },
  ];



// useEffect(()=>{
//   if(localStorage.getItem("editPropId") !="" || localStorage.getItem("editPropId") != undefined ||  localStorage.getItem("editPropId") != null){
//     var data ={
//       Id:parseInt(localStorage.getItem("editPropId"))
//     }
// dispatch(getPropertyById(data,(res)=>{
//   console.log(res)
//   const updateData={
//     locationName: res.data.result.LocationName || propertyRegData?.locationName,
//     locationCode: res.data.result.LocationCode || propertyRegData?.locationCode,
//     gstin: res.data.result.GSTIN || propertyRegData?.gstin,
//     addressL1:res.data.result?.AddressLine1||propertyRegData?.addressL1,
//     addressL2:res.data.result?.AddressLine2||propertyRegData?.addressL2,
//     addressL3:res.data.result?.AddressLine3||propertyRegData?.addressL3,
//     city:res.data.result?.City||propertyRegData?.city,
//     state:res.data.result?.State||propertyRegData?.state,
//     pinCode:res.data.result?.Pincode||propertyRegData?.pinCode,
//     superArea:res.data.result?.SuperArea||propertyRegData?.superArea,
// carpetArea:res.data.result?.CarpetArea||propertyRegData?.carpetArea,
// durationOfLease:res.data.result?.LeaseDuration ? new Date(res.data.result?.LeaseDuration).toISOString().split('T')[0] : ''||propertyRegData.durationOfLease ? new Date(propertyRegData.durationOfLease).toISOString().split('T')[0] : '', // Format date if needed
// startDate:res.data.result?.LeaseStartDate ? new Date(res.data.result?.LeaseStartDate).toISOString().split('T')[0] : ''||propertyRegData.startDate ? new Date(propertyRegData.startDate).toISOString().split('T')[0] : '', // Format date if needed
// endDate: res.data.result?.LeaseEndDate ? new Date(res.data.result?.LeaseEndDate).toISOString().split('T')[0] : ''||propertyRegData.endDate ? new Date(propertyRegData.endDate).toISOString().split('T')[0] : '', // Format date if needed

//   }
//   setFormData(updateData);
//     dispatch(setPropertyRegData(updateData))
//   setNewPropertyId(res.data.result.Id);
//   localStorage.setItem("propId",res.data.result.Id)
// },()=>{}))
//   }

//   return ()=>{
//     localStorage.removeItem("editPropId")
//   }
// },[])


useEffect(() => {
  const editPropId = localStorage.getItem("editPropId");
// console.log(editPropId)
  if (editPropId!==null) {
    const data = {
      Id: parseInt(editPropId)
    };

    dispatch(getPropertyById(data, (res) => {
      // console.log( res.data.result);

      const propertyResult = res.data.result;
      // const updateData = {
      //   locationName: res.data.result?.LocationName ,
      //   locationCode: res.data.result?.BranchCode ,
      //   gstin: res.data.result?.GSTIN ,
      //   addressL1: res.data.result?.AddressLine1 ,
      //   addressL2: res.data.result?.AddressLine2 ,
      //   addressL3: res.data.result?.AddressLine3 ,
      //   city: res.data.result?.City,
      //   state: res.data.result?.State,
      //   pinCode: res.data.result?.Pincode,
      //   superArea: res.data.result?.SuperArea ,
      //   carpetArea: res.data.result?.CarpetArea ,
      //   durationOfLease: res.data.result?.LeaseDuration ? new Date(res.data.result?.LeaseDuration+ 'Z').toISOString().split('T')[0]:'', // Format date if needed
      //   startDate: res.data.result?.LeaseStartDate ? new Date(res.data.result?.LeaseStartDate+ 'Z').toISOString().split('T')[0]: '', // Format date if needed
      //   endDate: res.data.result?.LeaseEndDate ? new Date(res.data.result?.LeaseEndDate+ 'Z').toISOString().split('T')[0] : '', // Format date if needed
      // };
      setFormData(res.data.result)
      // console.log("updated Data",updateData)
      setGstinFromApi(res.data.result.GSTIN)
      // setFormData(updateData);
      // dispatch(setPropertyRegData(updateData));
      setNewPropertyId(propertyResult.Id);
      localStorage.setItem("propId", propertyResult.Id);
    }, () => {}));
  }

  return () => {
    localStorage.removeItem("editPropId");
  };
}, [dispatch, propertyRegData]);


  // Function to handle change in form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue;

    if (name === 'Pincode') {
      updatedValue = value.slice(0, 6);
    } else if (name === 'SuperArea' || name === 'CarpetArea') {
      updatedValue = value === '' ? null : value;
    } else {
      updatedValue = value;
    }
  
    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  
       // Reset error state based on field name
       switch (name) {
        case 'LocationName':
          setIsPropertyNameError(false);
          break;
        case 'LocationCode':
          setIsLocationCodeError(false);
          break;
        case 'GSTIN':
          setIsGstinError(false);
          break;
        case 'AddressLine1':
          setIsAddressLineOne(false);
          break;
        case 'City':
          setIsCityNameError(false);
          break;
        case 'State':
          setIsStateNameError(false);
          break;
        case 'Pincode':
          setIsPincodeError(false);
          break;
                case 'LeaseStartDate':
                  setIsStartDateError(false);
                  break;
                  case 'LeaseEndDate':
                    setIsEndDateError(false);
                    break;
                    case 'LeaseDuration':
                      setIsDurationOfLeaseError(false);
                      break;
        default:
          break;
       }
  };
  function calculateLeaseDurationInMonths(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    let yearDiff = end.getFullYear() - start.getFullYear();
    let monthDiff = end.getMonth() - start.getMonth();
  
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }
  
    return parseInt(yearDiff * 12 + monthDiff); // Ensure it's an integer
  }

function handleSavePropertyAndProceed(){
  setApiLoading(true)
  if(newPropertyId === ''){
    var data ={
    
      // Id: 0,
      AddressLine1: formData.AddressLine1,
      AddressLine2: formData.AddressLine2,
      AddressLine3: formData.AddressLine3,
      City: formData.City,
      State: formData.State,
      Pincode: formData.Pincode,
      BranchCode: formData.BranchCode,
      GSTIN: formData.GSTIN,
      // LocationCode: formData.locationCode,
      SuperArea: formData.SuperArea===''?null:formData.SuperArea,
      CarpetArea: formData.CarpetArea===''?null:formData.CarpetAreaa,
      LeaseDuration: calculateLeaseDurationInMonths(formData.LeaseStartDate,formData.LeaseEndDate),
      LeaseStartDate: formData.LeaseStartDate,
      LeaseEndDate: formData.LeaseEndDate,
      LocationName: formData.LocationName,
    
  }
  dispatch(registerPropertyApi(data,(res)=>{
    setApiLoading(false)
    setNewPropertyId(res.data.result)
    localStorage.setItem("propId",res.data.result)
    dispatch(setPropertyRegData(null))

    setActiveStep(2);},()=>{
      setApiLoading(false)
  
    }))
  }else{
    var data ={
    
      Id: newPropertyId,
      AddressLine1: formData.AddressLine1,
      AddressLine2: formData.AddressLine2,
      AddressLine3: formData.AddressLine3,
      City: formData.City,
      State: formData.State,
      Pincode: formData.Pincode,
      BranchCode: formData.BranchCode,
      GSTIN: formData.GSTIN,
      // LocationCode: formData.locationCode,
      SuperArea: formData.SuperArea===''?null:formData.SuperArea,
      CarpetArea: formData.CarpetArea===''?null:formData.CarpetArea,
      LeaseDuration: calculateLeaseDurationInMonths(formData.LeaseStartDate,formData.LeaseEndDate),
      LeaseStartDate: formData.LeaseStartDate,
      LeaseEndDate: formData.LeaseEndDate,
      LocationName: formData.LocationName,
    
  }
  try {
    dispatch(updatePropertyApi(data,(res)=>{
      // setNewPropertyId(res.data.result)
      // localStorage.setItem("propId",res.data.result)
      setApiLoading(false)
      dispatch(setPropertyRegData(null))
      setActiveStep(2);},()=>{
        setApiLoading(false)
      }))
  } catch (error) {
    // console.log(error)
    toast.error("GSTIN does not exist")
  }
  }


}
// function getPartBeforeT(dateTimeString) {
//   // Check if the input string contains 'T'
//   const indexT = dateTimeString.indexOf('T');
  
//   // Return the substring before 'T' if found, otherwise return the original string
//   return indexT !== -1 ? dateTimeString.substring(0, indexT) : dateTimeString;
// }

// function resetState(){
 
//     setPropertyName("");
//     setLocationCode("");
//     setAddressLineOne("");
//     setAddressLineTwo("");
//     setAddressLineThree("");
//     setCityName("");
//     setStateName("");
//     setPincode("");
//     setSuperArea("");
//     setCarpetArea("");
//     setStartDate("");
//     setEndDate("");
//     setDurationOfLease("");
//     setGstin("");
//     setNewPropertyId("");
 
// }

const verifyGstin=async()=>{
  // dispatch(setLoading(true))
  setLoader(true)
  const data={
    gstin:formData.GSTIN
  }
try {
dispatch(getGstinDetailsApi(data,(res)=>{
// setNewPropertyId(res.data.result)
// localStorage.setItem("propId",res.data.result)
// console.log(res.data.data)
if(res.data.data===null){
  toast.error(res.data.message)
}else{
  toast.success("GSTIN validated successfully")
  setPropertyDetailsStep(propertyDetailsStep + 1);
}
const addressParts = [
  res.data.data?.addDoorNo,
  res.data.data?.addFloorNo,
  res.data.data?.addBuilding
];

const filteredAddress = addressParts.filter(part => part).join(',');
const UpdateStore={
  ...formData,
AddressLine1:filteredAddress||formData.addressL1,
AddressLine2:res.data.data?.addStreet||formData.addressL2,
AddressLine3:res.data.data?.addLocation||formData.addressL3,
City:res.data.data?.addDistrict||formData.city,
State:res.data.data?.addState||formData.state,
Pincode:res.data.data?.addPincode||formData.pinCode,
}
  dispatch(setPropertyRegData(UpdateStore))
setFormData(UpdateStore)
setLoader(false)
}))
setLoader(false)

} catch (error) {
  // dispatch(setLoading(false))
}
// dispatch(setLoading(false))
}

const submit=async()=>{
  if (propertyDetailsStep < propertyFormSteps.length) {
    if(propertyDetailsStep == 1){
      if(formData.LocationName !== ""&&formData.LocationName!==null && formData.BranchCode !=="" &&formData.BranchCode!==null&& formData.GSTIN!==""&&formData.GSTIN!==null ){
          dispatch(setPropertyRegData(formData))
          if(formData.GSTIN!==gstinFromApi){
             verifyGstin()
          }else if(formData.GSTIN!==''&&gstinFromApi!==''){
            setPropertyDetailsStep(propertyDetailsStep + 1);
          }
      //  if(propertyRegData.AddressLine1!==''){
      //   setPropertyDetailsStep(propertyDetailsStep + 1);
      //  }else
      //  toast.error('Please enter a valid GSTIN')
      // }
      
      }
      else{
        if(formData.LocationName === ""||formData.LocationName===null){
          setIsPropertyNameError(true)
        }else if(formData.BranchCode === ""||formData.BranchCode===null){
          setIsLocationCodeError(true)
        }
        else if(formData.GSTIN === ""||formData.GSTIN===null){
          console.log('gstin error in else')
          setIsGstinError(true)
        }
      }
    }else if(propertyDetailsStep == 2){
      if(formData.AddressLine1 !== ""&&formData.AddressLine1!==null&& formData.City !== ""&&formData.City!==null && formData.State !== ""&&formData.State!==null &&formData.Pincode!== ""&&formData.Pincode!==null){
        if(formData.Pincode.length<6){
toast.error("Pincode must be of 6 digits")
        }else{
          setPropertyDetailsStep(propertyDetailsStep + 1);
        dispatch(setPropertyRegData(formData))
        }
      }else{
        if(formData.AddressLine1 === ""||formData.AddressLine1===null){
          setIsAddressLineOne(true)
        }else if(formData.City === ""||formData.City===null){
          setIsCityNameError(true)
        }else if(formData.State ===""||formData.State===null){
          setIsStateNameError(true)
        }else if(formData.Pincode === ""||formData.Pincode===null){
          setIsPincodeError(true)
        }
      }
    }else if(propertyDetailsStep == 3){
        setPropertyDetailsStep(propertyDetailsStep + 1);
        dispatch(setPropertyRegData(formData))
    }
   
  } else {

    if(formData.LeaseStartDate !==""&&formData.LeaseStartDate!==null&&formData.LeaseStartDate!==undefined && formData.LeaseEndDate !==""&&formData.LeaseEndDate!==null&&formData.LeaseEndDate!==undefined && calculateLeaseDurationInMonths(formData.LeaseStartDate,formData.LeaseEndDate)!==null){
 console.log(formData.LeaseEndDate)
      handleSavePropertyAndProceed()
    }else{
      if(formData.LeaseStartDate === ""||formData.LeaseStartDate===null||formData.LeaseStartDate===undefined){
        setIsStartDateError(true)
      }else if(formData.LeaseEndDate === ""||formData.LeaseEndDate===null||formData.LeaseEndDate===undefined){
        setIsEndDateError(true)
      }else if (formData.LeaseDuration === ""||formData.LeaseDuration===null||formData.LeaseDuration===undefined){
setIsDurationOfLeaseError(true)
      }
    }
   
  }
}

const handleStep4=(val)=>{
  toast.success("You can see your registered property on Property List page.")
  setActiveStep(val);
}

  return (
    <>
    <ToastContainer/>
          <ResponceForAPI show={loader} />
      <h2 className="mb-2" style={{ color: "#124887" }}>
        Property Registration
      </h2>
      <p className="mb-3">Register New Property</p>

      <div className="card  " style={{ paddingTop: "10px" }}>
        <div className="" style={{ paddingBottom: "20px" }}>
          <CustomStepper activeStep={activeStep} stepsData={steps} />
        </div>
        <div
          style={{ border: "1px  dashed grey", height: "1px ", width: "100%" }}
        ></div>
        {activeStep === 1 && (
          <div>
            <div className="row">
              <div className="col-lg-4 col-xl-3">
                <VerticalStepper
                  activeStep={propertyDetailsStep}
                  stepsData={propertyFormSteps}
                />
              </div>
              <div className="col-lg-8 col-xl-9">
                <div
                  style={{
                    backgroundColor: "#F9F9F9",
                    padding: "2rem",
                  }}
                >
                  {propertyDetailsStep === 1 && (
                    <>
                      <h3>Property Details</h3>
                      <p className="mb-5">Tell us about your property.</p>

                      <InputField labelName={"Property Name*"} name='LocationName' onChange={handleChange} value={formData?.LocationName} errorOccured={isPropertyNameError } errorMeesage={"Property name is required"}/>

                      <InputField labelName={"Branch Code*"} name='BranchCode' onChange={handleChange} value={formData?.BranchCode} errorOccured={isLocationCodeError } errorMeesage={"Branch code is required"}/>

                      <InputField labelName={"GSTIN *"} name='GSTIN' onChange={handleChange} value={formData?.GSTIN} errorOccured={isGstinError } errorMeesage={"Gstin  is required"}/>
                    </>
                  )}
                  {propertyDetailsStep === 2 && (
                    <>
                      <h3>Address</h3>
                      <p className="mb-5">
                        Fields are fetched from Location Code. Please verify and
                        confirm details, also add appropriate details to empty
                        fields
                      </p>

                      <InputField labelName={"Address Line 1*"} name="AddressLine1" onChange={handleChange} value={formData?.AddressLine1} errorOccured={isAddressLineOne} errorMeesage={"Address Line 1 is required"}/>
                      <InputField labelName={"Address Line 2"} name="AddressLine2" onChange={handleChange} value={formData?.AddressLine2} />
                      <InputField labelName={"Address Line 3"} name="AddressLine3" onChange={handleChange}  value={formData?.AddressLine3} />
                      <InputField labelName={"City*"}name="City" onChange={handleChange} value={formData?.City} errorOccured={isCityNameError} errorMeesage={"City name is required"}/>
                      <InputField labelName={"State*"}name="State" onChange={handleChange} value={formData?.State} errorOccured={isStateNameError} errorMeesage={"State name is required"}/>
                      <InputField labelName={"Pincode*"} name="Pincode" onChange={handleChange} value={formData?.Pincode} errorOccured={isPincodeError} errorMeesage={"Pincode is required"}/>
                    </>
                  )}
                  {propertyDetailsStep === 3 && (
                    <>
                      <h3>Built Up</h3>
                      <p className="mb-5">
                        Fields are fetched from Location Code. Please verify and
                        confirm details, also add appropriate details to empty
                        fields
                      </p>

                      <InputField labelActivated labelName={"Super Area (sq ft)"}onChange={handleChange} name='SuperArea'   value={formData?.SuperArea} />
                      <InputField labelActivated labelName={"Carpet Area (sq ft)"} onChange={handleChange} name='CarpetArea'   value={formData?.CarpetArea} />
                    </>
                  )}


                  {propertyDetailsStep === 4 && (
                    <>
                      <h3>Validity</h3>
                      <p className="mb-5">
                        Tell us how long lease term will last
                      </p>
                    
                      <InputField labelActivated labelName={"Start Date*"} type="date"  name='LeaseStartDate'  onChange={handleChange} value={formData?.LeaseStartDate ? new Date(formData?.LeaseStartDate+ 'Z').toISOString().split('T')[0]:''} errorOccured={isStartDateError} errorMessage={"Start date is requiered"}  />
                      <InputField labelActivated labelName={"End Date*"} type="date"  name='LeaseEndDate' onChange={handleChange} value={formData?.LeaseEndDate ? new Date(formData?.LeaseEndDate+ 'Z').toISOString().split('T')[0]:''} errorOccured={isEndDateError} errorMessage={"End date is requiered"}  />
                      <InputField labelActivated labelName={"Term/Duration of Lease"}  name='LeaseDuration'  onChange={handleChange} value={calculateLeaseDurationInMonths(formData?.LeaseStartDate,formData?.LeaseEndDate)} errorOccured={calculateLeaseDurationInMonths(formData.startDate,formData.endDate)!==undefined?false:isDurationOfLeaseError} errorMeesage={"Duration of lease is required"} />
                    </>
                  )}


                  <div className="mt-5 d-flex justify-content-between">
                    {propertyDetailsStep > 1 ? (
                      <button
                        className="btn btn-primary"
                        style={{ minWidth: "150px" }}
                        onClick={() => {
                          if (propertyDetailsStep > 1) {
                            setPropertyDetailsStep(propertyDetailsStep - 1);
                          }
                        }}
                      >
                        Back
                      </button>
                    ) : (
                      <span></span>
                    )}
                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={submit}
                    >
                 {apiLoading ? "Saving": propertyDetailsStep == propertyFormSteps.length ? "Save and Proceed" : "Next"}    
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeStep === 2 && (
          <div>
            <div className="row">

              <div className="col-lg-12">
                <div
                  style={{
                    backgroundColor: "#F9F9F9",
                    padding: "2rem",
                  }}
                >
                  {serviceDetailsStep === 1 && (
                    <>

                     <ViewVendorsAddProperty/>
                    </>
                  )}



                  <div className="mt-5 d-flex justify-content-between">

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        if (serviceDetailsStep > 1) {
                          setServiceDetailsStep(serviceDetailsStep - 1);
                        } else {
                          setActiveStep(activeStep - 1)
                        }
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        if (serviceDetailsStep < ServiceFormSteps.length) {
                          setServiceDetailsStep(serviceDetailsStep + 1);
                        } else {
                          setActiveStep(3);
                        }
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeStep === 3 && (
          <div>
            <div className="row">

              <div className="col-12">
                <div
                  style={{
                    backgroundColor: "#F9F9F9",
                    padding: "2rem",
                  }}
                >
                  {serviceProviderStep === 1 && (
                    <>
<AssignUsers/>
                    </>
                  )}



                  <div className="mt-5 d-flex justify-content-between">

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        if (serviceProviderStep > 1) {
                          setServiceProviderStep(serviceProviderStep - 1);
                        } else {
                          setActiveStep(activeStep - 1)
                        }
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        if (serviceProviderStep < serviceProviderFormSteps.length) {
                          setServiceProviderStep(serviceProviderStep + 1);
                        } else {
                          handleStep4(4)
                        }
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeStep === 4 && (
          <div>
            <div className="row">

              <div >
                <div
                  style={{
                    backgroundColor: "#F9F9F9",
                    padding: "2rem",
                  }}
                >


                  <>
                    {/* <p className="mb-5">
                      You can always visit it by clicking VIEW ALL button on top-right  corner
                    </p> */}

                    <div>
                      <h2 className="d-flex justify-content-center">Registration Successful </h2>

                      <i className=" material-icons d-flex justify-content-center " style={{ fontSize: '200px', color: 'lightgreen' }}>
                        task_alt
                      </i>
                    </div>
                  </>



                  <div className="mt-5 d-flex justify-content-between">

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
                      onClick={()=>{navigate("/")}}
                    >
                      Go To Dashboard
                    </button>

                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "150px" }}
onClick={()=>{navigate("/propertyList")}}
                    >
                      Go To Property List
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default RegisterProperty;
